// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3hF9f","calendarButtons":"ClockData_calendarButtons__jcTFO"};